import { getCompetitionURL } from "app/helpers/navigationUtils";
import type { EventType } from "app/types/eventType";
import { useDispatch } from "react-redux";
import BackButton from "../BackButton/BackButton";
import { useEffect } from "react";

type Props = {
  event: EventType;
};

const Header: React.FC<Props> = ({ event }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      // Clear the event when the component unmounts
      dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(null);
    };
  }, [dispatch]);

  return (
    <header className="unsummarized-markets__header">
      {/*    
         Use cases:
            1. If the user navigated through the app's navigation, just go back.
            2. If the user landed directly on a specific event page (e.g., via a link or bookmark),
               and not through the app's navigation, redirect to the competition list,
               as they might be interested in other events from the same competition.
       */}
      <BackButton fallbackUrl={getCompetitionURL(event.competition.name)} />
    </header>
  );
};

export default Header;
